import {
  RecipientValidationFailureReason,
  RecipientValidationMultiResponseItem,
} from '@interfaces';
import { createReducer, on } from '@ngrx/store';

import * as RecipientValidationActions from '../../actions/recipient-validation/recipient-validation.actions';

export interface RecipientValidationState {
  attemptCount: number;
  accountEntries: {
    [accountId: string]: {
      valid: boolean;
      failureReasons: RecipientValidationFailureReason[];
    };
  };
  loading: boolean;
  multiValidationLoading: boolean;
  multiValidationResults: RecipientValidationMultiResponseItem[];
}

export const initialState: RecipientValidationState = {
  attemptCount: 0,
  accountEntries: {},
  loading: false,
  multiValidationLoading: false,
  multiValidationResults: [],
};

export const recipientValidationReducer = createReducer(
  initialState,
  on(RecipientValidationActions.validateRecipientAccount, (state) => ({
    ...state,
    loading: true,
  })),
  on(RecipientValidationActions.incrementAttemptCount, (state) => ({
    ...state,
    attemptCount: state.attemptCount + 1,
  })),
  on(
    RecipientValidationActions.setRecipientValidation,
    (state, { accountNumber, valid, failureReasons }) => ({
      ...state,
      accountEntries: {
        ...state.accountEntries,
        [accountNumber]: {
          valid,
          failureReasons: failureReasons || [],
        },
      },
      loading: false,
    }),
  ),
  on(RecipientValidationActions.validateMultiITAccounts, (state) => ({
    ...state,
    multiValidationLoading: true,
    multiValidationResults: [],
  })),
  on(RecipientValidationActions.setMultiITValidationResults, (state, { results }) => ({
    ...state,
    multiValidationLoading: false,
    multiValidationResults: results,
  })),
  on(RecipientValidationActions.clearMultiITValidationResults, (state) => ({
    ...state,
    multiValidationLoading: false,
    multiValidationResults: [],
  })),
);
